import { useState } from "react";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { useSession, LogoutReason } from "../Auth/hooks/useSession";
import AuthLogoutMessage from "../Auth/components/AuthLogoutMessage";
import { getFetchOptions } from "../../utils/fetch";
import useFetch from "../../hooks/useFetch";
import LoadingSpinner from "../../components/loadingSpinner/LoadingSpinner";
import Modal from "../../components/modals/Modal";
import MessageModal from "../../components/modals/MessageModal";
import BillableResellerPackages from "./components/BillableResellerPackages";
import ResellerPackages from "./components/ResellerPackages";
import Button, { ButtonType } from "../../components/Button";
import Alert, { AlertType } from "../../components/Alert";
import useFetchAuto from "../../hooks/useFetchAuto";

const EditReseller = (props) => {
	const { reason } = useSession();
	const [canSubmit, setCanSubmit] = useState(false);
	const { loading, data: availablePackages } = useFetchAuto("/api/ListAssignablePackages/");
	const { execute, executingFetch, error } = useFetch();
	const [selectedPackages, setSelectedPackages] = useState(props.items ?? []);

	function onClickCancel() {
		props.setOpenEditor(false);
	}

	function onClickConfirm(enable) {
		const options = getFetchOptions({
			method: "POST",
			body: selectedPackages
		});
		execute("/api/Reseller/Packages/" + props.resellerId, options, (error) => {
			if (error) {
				console.error(error.message);
			}
			else {
				props.setOpenEditor(false);
			}
			enable();
		});
	}

	function onCloseErrorModal() {
		window.location.reload();
	}

	const content = (
		<div>
			{!loading &&
				(props.master) ?
				(
					<BillableResellerPackages
						selectedPackages={selectedPackages}
						title={"Assign Packages"}
						availablePackages={availablePackages}
						setSelectedPackages={setSelectedPackages}
						setCanSubmit={setCanSubmit}
					/>
				) : (
					<ResellerPackages
						selectedPackages={selectedPackages}
						availablePackages={availablePackages}
						setSelectedPackages={setSelectedPackages}
						editing={true}
						title={"Assign Packages"}
						setCanSubmit={setCanSubmit}
					/>
				)
			}
		</div>
	);

	const buttons = (
		<>
			<Button type={ButtonType.Tertiary} label={"Cancel"} onClick={onClickCancel} />
			<Button
				type={ButtonType.Primary}
				disabled={!canSubmit}
				icon={faCircleCheck}
				label={"Confirm"}
				onClick={(e, c) => onClickConfirm(c)}
				disableUntilClickCompleted={true}
			/>
		</>
	);

	const ErrorModal = (
		<>
			{error &&
				<MessageModal title="Cannot edit Reseller" onClick={onCloseErrorModal} size="m">
					<Alert type={AlertType.Error}>{error.message}</Alert>
				</MessageModal>
			}
		</>
	);

	const EditModal = (
		<Modal
			title="Edit Reseller Packages"
			showModal={props.showModal}
			content={content}
			size="m"
			modalButtons={buttons}
			close={onClickCancel}
		/>
	);

	const render = () => {
		if (reason !== LogoutReason.None) {
			return <AuthLogoutMessage reason={reason} />;
		}
		if (executingFetch || loading) {
			return <LoadingSpinner active={executingFetch} />;
		}
		if (props.open) {
			if (error) {
				return ErrorModal;
			}
			return EditModal;
		}
		return <></>;
	}

	return (
		<>{render()}</>
	);
};

export default EditReseller;